var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThread(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/thread"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M8.20365 4.23446C7.85304 3.88384 7.28458 3.88384 6.93396 4.23445C6.58361 4.5848 6.5833 5.15273 6.93327 5.50345L9.71701 8.29327C10.1065 8.68362 10.1065 9.3156 9.71701 9.70594L6.93327 12.4958C6.5833 12.8465 6.58361 13.4144 6.93396 13.7648C7.28458 14.1154 7.85304 14.1154 8.20365 13.7648L12.2617 9.70672C12.6522 9.31619 12.6522 8.68303 12.2617 8.2925L8.20365 4.23446Z",
    fill: "#5D49C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon_2",
    d: "M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.022 16.2 1.8 12.978 1.8 9C1.8 5.022 5.022 1.8 9 1.8C12.978 1.8 16.2 5.022 16.2 9C16.2 12.978 12.978 16.2 9 16.2Z",
    fill: "#5D49C7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThread);
export default __webpack_public_path__ + "static/media/thread.af3ac1b0dbafc6bcec290352344a966a.svg";
export { ForwardRef as ReactComponent };